module.exports = __webpack_public_path__ + "img/art.aa10a18b.png";